import React from "react";
import { Typography, Divider } from "@material-ui/core";
import { blueGrey, grey } from '@material-ui/core/colors';

export default function BitcoinFAQ(props: any) {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            margin: 30,
        }}>
            <Typography style={{
                fontSize: 30,
                fontWeight: 400,
                color: 'black'
            }}>{props.title}</Typography>
            <Typography style={{
                color: grey[800],
            }} dangerouslySetInnerHTML={{ __html: props.description }} />
            <Divider color={blueGrey[300]} style={{
                marginTop: 10,
            }} />
        </div>
    );
}